import React, { useEffect, useState } from "react";
import TableDemo from "components/TableDemo";
import { SupportColumns } from "data/SupportColumns";
import api from "utils/apiService";

// const header
const Index = () => {
  const [data, setData] = useState({ data: [], pagination: { totalDocs: 0 } });
  const [loading, setLoading] = useState(true);
  const fetchData = async () => {
    try {
      const res = await api.get("/supportMessages");

      if (res.error) {
        console.error("API Error:", res.error);
      } else {
        setData({
          data: res?.data || [],
          pagination: res?.pagination || { totalDocs: 0 },
        });
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <section className="mt-3">
      <TableDemo
        data={data?.data}
        columns={SupportColumns(fetchData)}
        title="الشكاوي والاقتراحات"
        totalCount={data?.pagination?.totalDocs}
        loading={loading}
      />
    </section>
  );
};

export default Index;
